/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateEtcCardIssuanceRequest403Response
 */
export interface CreateEtcCardIssuanceRequest403Response {
    /**
     * 
     * @type {string}
     * @memberof CreateEtcCardIssuanceRequest403Response
     */
    'code': CreateEtcCardIssuanceRequest403ResponseCodeEnum;
}

export const CreateEtcCardIssuanceRequest403ResponseCodeEnum = {
    validationError: 'etc-validation-error',
    cardNameDuplicate: 'etc-card-name-duplicate',
    cardLimitExceeded: 'etc-card-limit-exceeded',
    creditInsufficient: 'etc-credit-insufficient',
    issuerPermissionDenied: 'etc-issuer-permission-denied',
    issuerNotFound: 'etc-issuer-not-found',
    holderInvalidRole: 'etc-holder-invalid-role',
    holderNotFound: 'etc-holder-not-found',
    systemError: 'etc-system-error'
} as const;

export type CreateEtcCardIssuanceRequest403ResponseCodeEnum = typeof CreateEtcCardIssuanceRequest403ResponseCodeEnum[keyof typeof CreateEtcCardIssuanceRequest403ResponseCodeEnum];


